<script setup lang="ts">
  import { DepartureCitySearch } from '@/features/searchForm/departureCity';
  import MobilePageHeader from '@/shared/ui/MobilePageHeader.vue';
  import MobileScreen from '@/shared/ui/MobileScreen.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <MobileScreen
    name="mobile-departure-screen"
    testid="search-form-mobile-departure"
    :embedded="flow.embedded"
  >
    <MobilePageHeader
      class="mobile-departure-screen__header"
      :title="flow.texts.labels.departure"
      @back="flow.back"
    />
    <div class="mobile-departure-screen__body">
      <DepartureCitySearch
        mobile
        :model-value="flow.fromCity.value"
        :cities="flow.cities.value"
        @update:modelValue="flow.updateFromCity"
        @select="flow.onDepartureSelect"
      />
    </div>
  </MobileScreen>
</template>

<style scoped lang="scss">
  .mobile-departure-screen {
    background: var(--color-bg-primary);

    &__header {
      flex: 0 0 auto;
      padding: var(--spacing-s) var(--spacing-m) var(--spacing-xs) var(--spacing-m);
    }

    &__body {
      box-sizing: border-box;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      overflow-y: auto;
      padding: var(--spacing-xs) var(--spacing-m) var(--spacing-l);
    }
  }
</style>
